import React, {
  useState,
  useCallback,
  useMemo,
  useReducer,
  useEffect,
} from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Paging,
  Pager,
  MasterDetail,
  Editing,
  FormItem,
  RequiredRule,
  Label,Button
} from "devextreme-react/data-grid";
import reducer from "../../reducer.js";
import {
  saveChange,
  loadOrders,
  setChanges,
  setEditRowKey,
} from "./actions.js";
import Button1 from "@material-ui/core/Button";
import swal from "sweetalert";
import axios from "axios";
import Guid from "devextreme/core/guid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import ShipmentProcessMasterDetailView from "./ShipmentProcessMasterDetailView";
import { api_path } from "../../shared.js";
export function ShipmentProcessDataGrid(props) {
  const classes = useStyles();
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_ID);
  const [getEmpID, setEmpID] = useState(props.EMP_CODE);
  const pageSizes = [25, 50, 100];
  const url =
    api_path +
    "/MS_SHIPMENT_PROCESS.php?SALES_CODE=" +
    getEmpID +
    "&role=" +
    getUserRole;
  const dataSource = createStore({
    key: "SHIPMENT_ID",
    loadUrl: `${url}`,
  });
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const handleAddButtonClick = React.useCallback((e) => {
    navigate({
      pathname: "/s-crm/ShipmentProcessForm",
      search: "",
    });
  }, []);
  const onCopyButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open("/s-crm/ShipmentProcessForm?param="+ e.row.key+"&copy=1", "_blank");
  }, []);
  const onEditButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open("/s-crm/ShipmentProcessForm?param="+ e.row.key, "_blank");
  }, []);
  const onCartButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open("/s-crm/SalesOrderForm?param="+ e.row.key, "_blank");
  }, []);
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const cellPrepared = (e) => {};
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "ShipmentProcess.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const navigate = useNavigate();
  const initialState = {
    data: [],
    changes: [],
    editRowKey: null,
    isLoading: false,
  };
  const [events, setEvents] = useState([]);
  const [state, dispatch] = useReducer(reducer, initialState);
  const changesText = useMemo(
    () =>
      JSON.stringify(
        state.changes.map((change) => ({
          type: change.type,
          key: change.type !== "insert" ? change.key : undefined,
          data: change.data,
          userid: getUserID,
        })),
        null,
        " "
      ),
    [state.changes]
  );
  const onSaving = useCallback((e) => {
    e.cancel = true;
    e.promise = saveChange(dispatch, e.changes[0]);
  }, []);
  const onChangesChange = useCallback((changes) => {
    setChanges(dispatch, changes);
  }, []);
  const onEditRowKeyChange = useCallback((editRowKey) => {
    setEditRowKey(dispatch, editRowKey);
  }, []);

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <label className="head">Shipment Process</label>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>
        <Grid
          item
          xs={12}
          sm={3}
          style={{ display: "flex" }}
          justify-content="flex-end"
        >
          <Button1
            className="addBtn"
            //disabled={!isButtonDisabled}
            type="button"
            variant="contained"
            color="primary"
            onClick={handleAddButtonClick}
          >
            New
          </Button1>
        </Grid>
      </Grid>
      <Grid container className={classes.root}>
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          showScrollbar={true}
          keyExpr="SHIPMENT_ID"
          onExporting={onExporting}
          allowColumnResizing={true}
          //onSaving={onSaving}
          //onChangesChange={onChangesChange}
        >
          {/* <Editing
            mode="form"
            allowAdding
            allowDeleting
            allowUpdating
            changes={state.changes}
            onChangesChange={onChangesChange}
            editRowKey={state.editRowKey}
            onEditRowKeyChange={onEditRowKeyChange}
          />
         */}
          <Paging enabled={true} />
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <MasterDetail
            enabled={true}
            component={ShipmentProcessMasterDetailView}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column dataField="SHIPMENT_ID" caption="ID">
            <FormItem visible={false} />
          </Column>
          <Column dataField="BOUND_TYPE" caption="BOUND TYPE" visible={false}/>
          <Column dataField="SHIPMENT_TERM" caption="SHIPMENT TERM" visible={false}/>
          <Column dataField="SHIPPER_CODE" visible={false} />
          <Column
            dataField="SHIPPER_NAME"
            caption="SHIPPER"
            allowHiding={false}
          >
            <RequiredRule />
          </Column>
          <Column dataField="CNEE_NAME">
            {/* <FormItem
              colSpan={2}
              cssClass="custom-class"
              editorType="dxTextArea"
              editorOptions="{ defaultEditorOptions }"
            >
              <Label location="top" />
            </FormItem> */}
          </Column>
          <Column dataField="SHIPPERLOAD_CODE" visible={false} />
          <Column
            dataField="SHIPPERLOAD_NAME"
            caption="SHIPPERLOAD"
            allowHiding={false}
          />
          <Column dataField="COLOAD_CODE" visible={false} />
          <Column dataField="COLOAD_NAME" caption="COLOAD" />
          <Column dataField="AGENT_CODE" visible={false} />
          <Column dataField="AGENT_NAME" caption="AGENT" />
          <Column dataField="POR" />
          <Column dataField="POL" />
          <Column dataField="POD" />
          <Column dataField="DEL" />
          <Column dataField="FINAL" visible={false}/>
          <Column dataField="CTNR_SIZE" caption="SIZE" visible={false}/>
          <Column dataField="CTNR_TYPE" caption="TYPE" visible={false}/>
          <Column dataField="DOOR_BY" visible={false} />
          <Column dataField="INCOTERM" visible={false} />
          <Column dataField="CHARGE_TERM" visible={false} />
          <Column dataField="BL_TYPE" visible={false} />
          <Column dataField="MBL_TYPE" visible={false} />
          <Column dataField="HBL_TYPE" visible={false} />
          <Column dataField="SHIPPING_CODE" visible={false} />
          <Column dataField="SHIPPING" visible={false} />
          <Column dataField="TRUCKING_CODE" visible={false} />
          <Column dataField="TRUCKING" visible={false} />
          <Column dataField="INSURANCE" visible={false} />
          <Column dataField="CREDIT_TERM" visible={false} />
          <Column dataField="AGENT_SALES_EMAIL" visible={false} />
          <Column dataField="ISF_BY" visible={false} />
          <Column dataField="AMS_SCAC" visible={false} />
          <Column dataField="ACI_SCAC" visible={false} />
          <Column dataField="FILING_BY" visible={false} />
          <Column dataField="PREALERT_EMAIL" visible={false} />
          <Column dataField="BOOKING_PIC" visible={false} />
          <Column dataField="DOC_PIC" visible={false} />
          <Column dataField="HSCODE" visible={false}/>
          <Column dataField="COMMODITY" visible={false}/>
          <Column dataField="GW" visible={false} />
          <Column dataField="REMARK_TO_CS" visible={false} />
          <Column dataField="REMARK_TO_DOC" visible={false} />
          <Column dataField="REMARK_TO_ACC" visible={false} />
          <Column type="buttons" width={40}>
            <Button
              icon="edit"
             onClick={onEditButtonClick}
              hint="Edit SOP"
            />
          </Column>

      
          <Column type="buttons" width={40}>
            <Button
              icon="copy"
              onClick={onCopyButtonClick}
              hint="Copy SOP"
              // visible={isCopyIconVisible}
            />
          </Column>
          <Column type="buttons" width={40}>
            <Button
              icon="cart"
             onClick={onCartButtonClick}
              hint="Booking job"
            />
          </Column>
          <LoadPanel enabled={true} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
        <div className="option">
          <span>Changes:</span>
          <div id="changes">{changesText}</div>
        </div>
        <ul>
          {events.map((event, index) => (
            <li key={index}>{event}</li>
          ))}
        </ul>
      </Grid>
    </Container>
  );
}
